import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    //overflow: ${(props) => (props.open ? 'auto' : 'hidden')};
    overflow-x: hidden;
  }
`;
